import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';

import { RoutePath } from '@components/AppRouter/constants';

export const GoPreparationOfReportsButton = ({ packageCode }: { packageCode?: string }): React.ReactElement => {
  const setLocalData = useCallback(
    () => localStorage.setItem('pushFromDataControl', JSON.stringify({ packageCode })),
    [packageCode],
  );

  return (
    <Tooltip content='Переход в раздел "Реестр подготовки отчетности"'>
      <Link
        onContextMenu={setLocalData}
        onMouseUp={setLocalData}
        onClick={(e) => {
          e.stopPropagation();
          setLocalData();
        }}
        to={{ pathname: RoutePath.PREPARATION_OF_REPORTS }}
      >
        <Icon name="listAlt" fill="#547DB1" />
      </Link>
    </Tooltip>
  );
};
